import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  productPackageApi,
  ProductPackageDetails,
} from "../../api/productPackageApi";
import { useApiRequestCallback } from "../../hooks/useApi/useApiRequestCallback";
import { ServerError } from "../../types";
import { ErrorDetails } from "../shared/ErrorDetails";
import { LoadingIndicator } from "../shared/LoadingIndicator";

export function CreateProductPackageModal({
  customerId,
  onClose,
  onSuccess,
}: {
  customerId: string;
  onClose: () => void;
  onSuccess: (productPackage: ProductPackageDetails) => void;
}) {
  const [error, setError] = useState<ServerError>();
  const { register, handleSubmit } = useForm<AddProductPackageFormData>();
  const [loading, request] = useApiRequestCallback(
    productPackageApi.createProductPackage,
  );

  const { t } = useTranslation();

  function onSubmit(data: AddProductPackageFormData) {
    request({ onSuccess, onError: setError }).send({
      customerId,
      name: data.name,
    });
  }
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {error && <ErrorDetails error={error} />}
        {loading && <LoadingIndicator />}
        <ModalHeader>
          {t("general.add")} {t("productPackage.productPackage").toLowerCase()}
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <ModalBody>
            <FormControl isRequired={true}>
              <FormLabel>{t("general.name")}</FormLabel>
              <Input
                {...register("name", {
                  required: { value: true, message: t("error.required") },
                })}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button type="submit">{t("general.save")}</Button>
          </ModalFooter>
        </form>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
}

interface AddProductPackageFormData {
  name: string;
}
